import { useState, useEffect } from 'react'

export function useIsMobile(breakpoint = 450) {
	const [isMobile, setIsMobile] = useState(
		() => window.innerWidth <= breakpoint
	)

	useEffect(() => {
		const mql = window.matchMedia(`(max-width: ${breakpoint}px)`)
		const handler = e => setIsMobile(e.matches)

		mql.addEventListener
			? mql.addEventListener('change', handler)
			: mql.addListener(handler)

		return () => {
			mql.removeEventListener
				? mql.removeEventListener('change', handler)
				: mql.removeListener(handler)
		}
	}, [breakpoint])

	return isMobile
}
